module.exports = __webpack_public_path__ + "media/images/save-hover-3e9fbba744f2629a843590d7c07e59b6.svg";